import React from 'react';
import { ArrowLeft, X } from '@phosphor-icons/react';
import { Logo } from '../layout/Logo';
interface PropertyWizardHeaderProps {
  title: string;
  canGoBack: boolean;
  onBack: () => void;
  onClose: () => void;
}
export function PropertyWizardHeader({
  title,
  canGoBack,
  onBack,
  onClose
}: PropertyWizardHeaderProps) {
  return <header className="sticky top-0 z-50 w-full bg-dark-1 border-b border-dark-3" data-id="element-2496">
      <div className="max-w-3xl mx-auto px-4 h-16 flex items-center justify-between gap-3" data-id="element-2497">
        <div className="flex items-center gap-2 min-w-0" data-id="element-2498">
          {canGoBack ? <button onClick={onBack} aria-label="Înapoi" className="p-2 -ml-2 rounded-md text-light-3 hover:text-light-1 hover:bg-dark-2 transition-colors" data-id="element-2499">
              <ArrowLeft className="w-5 h-5" weight="bold" data-id="element-2500" />
            </button> : <Logo className="h-6 w-auto" onClick={onClose} data-id="element-2501" />}
          <span className="text-sm font-medium text-light-1 truncate" data-id="element-2502">
            {title}
          </span>
        </div>

        <button onClick={onClose} aria-label="Închide" className="p-2 -mr-2 rounded-md text-light-3 hover:text-light-1 hover:bg-dark-2 transition-colors" data-id="element-2503">
          <X className="w-5 h-5" weight="bold" data-id="element-2504" />
        </button>
      </div>
    </header>;
}